// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import opinionDocumentEntity from './entities/opinion-document.json';
import opinionDocumentMenu from '../pages/opinion-document/menu.json';
import opinionDocumentFullForm from '../pages/opinion-document/forms/full.json';
import opinionDocumentContextForm from '../pages/opinion-document/forms/context.json';
import opinionDocumentMiniForm from '../pages/opinion-document/forms/mini.json';
import opinionDocumentLookupForm from '../pages/opinion-document/forms/lookup.json';
import opinionDocumentTableView from '../pages/opinion-document/views/table.json';
import opinionDocumentCardsView from '../pages/opinion-document/views/cards.json';
import opinionDocumentCalendarView from '../pages/opinion-document/views/calendar.json';
import opinionDocumentDashboardView from '../pages/opinion-document/views/dashboard.json';

/** Тип запису «Документ висновку» зі сторінками пакета: меню, форми та подання з pages/opinion-document/. */
export const opinionDocumentDefinition: IRecordTypeDefinition = {
  ...opinionDocumentEntity,
  views: assembleViewSet({
      table: opinionDocumentTableView,
      cards: opinionDocumentCardsView,
      calendar: opinionDocumentCalendarView,
      dashboard: opinionDocumentDashboardView,
  }),
  form: opinionDocumentFullForm,
  forms: { full: opinionDocumentFullForm, context: opinionDocumentContextForm, mini: opinionDocumentMiniForm, lookup: opinionDocumentLookupForm },
  menu: opinionDocumentMenu,
} as IRecordTypeDefinition;
